import { useMemo } from 'react';
import lightenDarkenColor from '../utils/lightenDarkenColor';
import getColorBasedOnBgColor from '../utils/getColorBasedOnBgColor';
import { COLORS } from '../styles/variables';
import { VehicleInfo } from '../types';

const usePalette = (
  vehicleData: VehicleInfo | undefined,
): {
  backgroundColor: string;
  darkenedBackgroundColor: string;
  textColor: string;
  statusTextColor: string;
  statusBgColor: string;
  popUpBgColor: string;
} => {
  const backgroundColor = vehicleData?.dominantExteriorColor || '#999999';

  const darkenedBackgroundColor = useMemo(
    () => `#${lightenDarkenColor(backgroundColor, -7)}`,
    [backgroundColor],
  );

  const textColor = useMemo(
    () => getColorBasedOnBgColor(backgroundColor, COLORS.white, COLORS.black),
    [backgroundColor],
  );

  const statusTextColor = useMemo(
    () => getColorBasedOnBgColor(backgroundColor, COLORS.audiSilver, COLORS.grey60),
    [backgroundColor],
  );

  const statusBgColor = useMemo(
    () => getColorBasedOnBgColor(backgroundColor, COLORS.whiteOpacity, COLORS.skeletonColor),
    [backgroundColor],
  );

  const popUpBgColor = useMemo(
    () => getColorBasedOnBgColor(backgroundColor, COLORS.black, COLORS.grey80),
    [backgroundColor],
  );

  const paletteBag = useMemo(
    () => ({
      backgroundColor,
      darkenedBackgroundColor,
      textColor,
      statusTextColor,
      statusBgColor,
      popUpBgColor,
    }),
    [
      backgroundColor,
      darkenedBackgroundColor,
      popUpBgColor,
      statusBgColor,
      statusTextColor,
      textColor,
    ],
  );

  return paletteBag;
};

export default usePalette;
